<ng-container *ngIf="cards > 0">
    <div class="row">
        <ng-container *ngFor="let summaryView of summaryViews">
            <ng-container *ngIf="summaryView.fullWidth;else partial">
                <div class="col-md-12">
                    <ng-container *ngIf="summaryView.type === 'single';else wideList">
                        <ubs-ofbiz-summary-form [summaryView]="summaryView" [fieldList]="fieldList" [existingValues]="existingValues"></ubs-ofbiz-summary-form>
                    </ng-container>
                    <ng-template #wideList>
                        <ubs-ofbiz-summary-list [summaryView]="summaryView" [fieldList]="fieldList" [existingValues]="existingValues"></ubs-ofbiz-summary-list>
                    </ng-template>
                </div>
            </ng-container>
            <ng-template #partial>
                <div class="col-md-6">
                    <ng-container *ngIf="summaryView.type == 'single';else singleList">
                        <ubs-ofbiz-summary-form [summaryView]="summaryView" [fieldList]="fieldList" [existingValues]="existingValues"></ubs-ofbiz-summary-form>
                    </ng-container>
                    <ng-template #singleList>
                        <ubs-ofbiz-summary-list [summaryView]="summaryView" [fieldList]="fieldList" [existingValues]="existingValues"></ubs-ofbiz-summary-list>
                    </ng-template>
                </div>
            </ng-template>
        </ng-container>
    </div>
</ng-container>

